package localstorage

enum class LocalStorageKeys {
    LocalSettings
    ;

    fun key(): String = "com.tryformation.webapp.${this.name.replaceFirstChar { 
        if (it.isUpperCase()) it.lowercase() else it.toString() 
    }}"
}